import {
  MODULE_ORDER,
  MODULE_STATIC_CONFIG,
  SMART_CHECKOUT_ID,
  SMART_MERCHANDISING_ID,
  SMART_PRICING_LIMITED_ID,
  SMART_PRICING_UNLIMITED_ID,
  SMART_PRICING_VARIANTS,
  SMART_SHIPPING_ID,
  UNLIMITED_ID,
} from "./constants";

type BillingGatePresentation = Readonly<{
  includedModuleNames?: readonly string[];
  videoPlaybackId?: string;
}>;

const firstSmartPricingOrderIndex = MODULE_ORDER.findIndex((id) =>
  SMART_PRICING_VARIANTS.has(id)
);

const UNLIMITED_INCLUDED_MODULE_NAMES = Object.freeze(
  MODULE_ORDER.filter(
    (id, index) =>
      !SMART_PRICING_VARIANTS.has(id) || index === firstSmartPricingOrderIndex
  ).map((id) => MODULE_STATIC_CONFIG[id]?.name ?? id)
);

const MUX_PLAYBACK_IDS: Readonly<Record<string, string>> = Object.freeze({
  [SMART_CHECKOUT_ID]: "Y2uxPxOZt01vr00wey1T7AGu8AW3ZeiyxqqPdKDp01uENo",
  [SMART_MERCHANDISING_ID]: "6wdO9SjBtROFGDyDtPy0001HC6sAunUXolxgXpJQGO3uA",
  [SMART_PRICING_LIMITED_ID]: "gNYZQ9SFb01fvZY4Ov2IBfXC1102yjQPdXBDjrgVbLFlk",
  [SMART_PRICING_UNLIMITED_ID]: "gNYZQ9SFb01fvZY4Ov2IBfXC1102yjQPdXBDjrgVbLFlk",
  [SMART_SHIPPING_ID]: "WbKvR1vbVH5wbqdfJlreSQT5iRcgyf0200jVBim6ATvWg",
  [UNLIMITED_ID]: "Il026I7NdzWJpwGtabagQlUkwOSN8xnHmG51hNRH4uRk",
});

export const getBillingGatePresentation = (
  moduleId: string
): BillingGatePresentation => {
  const videoPlaybackId = MUX_PLAYBACK_IDS[moduleId];

  return {
    ...(videoPlaybackId ? { videoPlaybackId } : {}),
    ...(moduleId === UNLIMITED_ID
      ? { includedModuleNames: UNLIMITED_INCLUDED_MODULE_NAMES }
      : {}),
  };
};
